/* eslint-disable react/require-default-props */
import React, { useState } from 'react';

// Material UI
import { TextField, FormControl, MenuItem } from '@material-ui/core';

// Components
import { MaskedInputCurrency, MaskedInputPercent } from 'components';

// Constants
import SIMBOLS from 'constants/symbolsType';

interface benefitType {
  name: 'FIXED_VALUE' | 'PERCENTAGE' | string;
  value: 'R$' | '%' | string;
}

interface TextFieldDiscountProps {
  value: string;
  defaultValue?: string;
  onChange?: (e: any) => void;
  buttonOnClick?: (benefitType: benefitType) => void;
  [x: string]: any;
}

export function TextFieldDiscount({
  value,
  defaultValue,
  onChange,
  buttonOnClick,
  buttonLabel,
  disabled,
  ...restProps
}: TextFieldDiscountProps) {
  const [benefitType, setbenefitType] = useState<benefitType>({
    name: 'FIXED_VALUE',
    value: 'R$',
  });

  // Rule for mask
  const MaskedInputSelected =
    benefitType.name === 'FIXED_VALUE'
      ? MaskedInputCurrency
      : MaskedInputPercent;

  const changeBenefitType = (name: string) => {
    if (name === 'FIXED_VALUE') {
      setbenefitType({ name: 'PERCENTAGE', value: '%' });
    } else {
      setbenefitType({ name: 'FIXED_VALUE', value: 'R$' });
    }
  };

  return (
    <FormControl
      fullWidth
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <TextField
        variant='outlined'
        disabled={disabled}
        value={value}
        fullWidth
        InputProps={{ inputComponent: MaskedInputSelected as any }}
        onChange={(e) => {
          if (onChange) onChange(e);
        }}
        {...restProps}
      />
      {buttonLabel || (
        <TextField
          defaultValue={defaultValue}
          disabled={disabled}
          style={{ width: 95, marginTop: 7 }}
          fullWidth
          id='text-field-discount'
          margin='normal'
          select
          onChange={async () => {
            await changeBenefitType(benefitType.name);
            if (buttonOnClick) {
              buttonOnClick(benefitType);
            }
          }}
          value={defaultValue || benefitType.value}
          variant='outlined'>
          {SIMBOLS.map((s) => (
            <MenuItem key={s.id} value={s.symbol}>
              {s.symbol}
            </MenuItem>
          ))}
        </TextField>
      )}
    </FormControl>
  );
}

export default TextFieldDiscount;
